import {
  Button,
  DatePickerOld,
  Modal,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { AsyncStatus, Queue } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import moment from 'moment-timezone';
import * as React from 'react';

import '../style/follow-up-modal.less';

type PropsT = {
  queuesState: { queues: Array<Queue>; asyncStatus: AsyncStatus };
  timestamp: string | null;
  csid: number | null;
  conversationQueueId?: string;
  ui: any;

  setConversationToPending: (payload: {
    csid: number;
    duration: number;
  }) => Promise<any>;
  modalClose: () => void;
  getAllQueues: () => void;
};

type StateT = {
  selectedQueueId: string | null;
  selectedDate: Date;
  minDate: Date;
};

export default class FollowUpModal extends React.Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);

    this.state = {
      selectedQueueId: null,
      ...this.getSelectedAndMinDate(),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: PropsT) {
    if (
      this.props.ui.isModalShown === false &&
      nextProps.ui.isModalShown === true
    ) {
      if (nextProps.ui.queueSelection) {
        this.props.getAllQueues();
      }
    }

    let nextState = {};
    if (this.props.ui.isModalShown === false && nextProps.ui.isModalShown) {
      nextState = this.getSelectedAndMinDate();
    }

    if (nextProps.queuesState.asyncStatus === 'succeeded') {
      const { conversationQueueId } = nextProps;
      const defaultQueue: Queue | undefined = nextProps.queuesState.queues.find(
        (q: Queue) => q.is_default,
      );

      if (defaultQueue) {
        nextState = {
          ...nextState,
          defaultQueueId: defaultQueue.id,
          selectedQueueId: conversationQueueId
            ? conversationQueueId
            : defaultQueue.id,
        };
      }
    }

    if (Object.keys(nextState).length) {
      this.setState(nextState);
    }
  }

  getSelectedAndMinDate() {
    const minDate = new Date();
    minDate.setHours(minDate.getHours() + 1, 0, 0, 0);

    const selectedDate = new Date();
    selectedDate.setHours(selectedDate.getHours() + 1, 0, 0, 0);

    return {
      selectedDate,
      minDate,
    };
  }

  _queuesToSelectOptions = (queue: Queue) => (
    <option key={queue.id} value={queue.id}>
      {queue.name}
    </option>
  );

  _handleQueueChange = (event: any) => {
    this.setState({ selectedQueueId: event.target.value });
  };

  _handleDatePickerChange = (date: Date) => {
    this.setState({ selectedDate: date });
  };

  _handleSubmit = (e: Event) => {
    const { csid, modalClose, timestamp, setConversationToPending, ui } =
      this.props;

    e.preventDefault();
    const followUpDetails = {
      csid,
      timestamp: timestamp || moment(this.state.selectedDate).utc().format(),
      queueId: ui.queueSelection ? this.state.selectedQueueId : null,
    };

    setConversationToPending(followUpDetails as any).then(() => {
      if (csid) {
        ampli.conversationFollowUp({ conversationId: csid });
      }
      modalClose();
    });
  };

  getIcon = () => {
    if (this.props.timestamp && this.props.ui.queueSelection) {
      return 'users';
    }

    return 'calendar';
  };

  _renderTitle = (): string => {
    if (this.props.ui.queueSelection) {
      if (this.props.timestamp) {
        return 'Select queue for follow-up';
      }
      return 'Pick a date & select a queue';
    }
    return 'Pick a date';
  };

  _renderDatePicker = () => {
    const { selectedDate } = this.state;

    return this.props.timestamp ? null : (
      <DatePickerOld
        minDate={this.state.minDate}
        input={{
          name: 'date',
          value: selectedDate,
          onChange: this._handleDatePickerChange as any,
        }}
        hasTime
      />
    );
  };

  _renderSeparator = (): React.ReactNode => {
    if (!this.props.timestamp && this.props.ui.queueSelection) {
      return <div className="follow-up-modal__divider"></div>;
    }

    return null;
  };

  _renderQueues = (): React.ReactNode => {
    const { queuesState } = this.props;
    const { queues, asyncStatus } = queuesState;

    if (!this.props.ui.queueSelection) {
      return null;
    }

    if (asyncStatus !== 'succeeded' && queues.length === 0) {
      return (
        <div className="follow-up-modal__queue-selector--loading">
          <b>Loading...</b>
        </div>
      );
    }

    if (asyncStatus === 'succeeded' && queues.length === 0) {
      return (
        <div className="follow-up-modal__queue-selector--empty">
          <b>No queues found</b>
        </div>
      );
    }
    if (asyncStatus === 'succeeded' && queues.length > 0) {
      return (
        <React.Fragment>
          <div className="row-item follow-up-modal__queue-description">
            The conversation will be offered as an open conversation in the
            selected queue when the follow-up expires.
          </div>
          <label htmlFor="queue" className="follow-up-modal__queue-label">
            Queue
          </label>
          <select
            id="queue"
            name="queueId"
            className="follow-up-modal__queue-selector"
            value={this.state.selectedQueueId as string}
            onChange={this._handleQueueChange}
          >
            {queues.map(this._queuesToSelectOptions)}
          </select>
        </React.Fragment>
      );
    }

    return null;
  };

  render() {
    return (
      <Modal
        className="follow-up-modal"
        isOpen={this.props.ui.isModalShown}
        onClose={this.props.modalClose}
      >
        <ModalHead
          title={this._renderTitle() as any}
          onClose={this.props.modalClose}
        />
        <div className="follow-up-modal__body">
          {this._renderDatePicker()}
          {this._renderSeparator()}
          {this._renderQueues()}
          <div className="follow-up-modal__buttons">
            <Button
              type="button"
              variant="secondary"
              onClick={this.props.modalClose}
            >
              Cancel
            </Button>
            <Button type="button" onClick={this._handleSubmit as any}>
              Mark as follow-up
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
